module.exports = __webpack_public_path__ + "static/media/stripe-black.b4f6134f.svg";